<template>
  <BasePage title="Files">

    <div class="columns">

      <div class="column">

        <FilesVideos/>

      </div>

      <div class="column">

        <FilesResources/>

      </div>
    </div>

  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import FilesResources from './FilesResources.vue'
import FilesVideos from './FilesVideos.vue'

export default {
  name: 'files',
  components: {
    BasePage,
    FilesResources,
    FilesVideos,
  },
}

</script>



// WEBPACK FOOTER //
// Files.vue?0ec35b00